import { render } from "./AdminView.vue?vue&type=template&id=0994800f&scoped=true"
import script from "./AdminView.vue?vue&type=script&lang=js"
export * from "./AdminView.vue?vue&type=script&lang=js"

import "./AdminView.vue?vue&type=style&index=0&id=0994800f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0994800f"

export default script